import { memo } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDatePicker, { CalendarContainer } from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import vi from 'date-fns/locale/vi';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import { Element } from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';
registerLocale('vi', vi);

interface IProps {
    date: Date;
    isSelected?: boolean;
}

const DatePicker = ({ date }: IProps) => {
    const router = useRouter();
    const CustomizedCalendarContainer = ({
        className,
        children,
    }: {
        className: string;
        children: any;
    }) => {
        return (
            <div className={styles['calendar-container']}>
                <CalendarContainer className={className}>
                    <div style={{ position: 'relative' }}>{children}</div>
                </CalendarContainer>
            </div>
        );
    };

    const onChange = (date: Date) => {
        const _date = dayjs(date).format('YYYY-MM-DD');
        router.push(`${URL_SOCCER_PAGE.LIVESCORE}?date=${_date}`);
    };

    return (
        <Element className={styles['ut-date-picker']}>
            <ReactDatePicker
                selected={date}
                onChange={onChange}
                onSelect={onChange}
                className={styles['date-picker']}
                calendarContainer={CustomizedCalendarContainer}
                locale="vi"
                dateFormat={'dd-MM-yyyy'}
                inline
            />
        </Element>
    );
};

export default memo(DatePicker);
